import { defineMessages } from '@transcend-io/internationalization';

export const aboutTranscendWidgetMessages = defineMessages(
  'privacy-center.components.AboutTranscendWidget.aboutTranscendWidget',
  {
    aboutTranscend: {
      defaultMessage: "We're taking a different approach to privacy",
      description: 'Text for about Transcend widget',
    },
    buttonMessage: {
      defaultMessage: 'Show Me',
    },
  },
);
